/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-03-08 14:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle, Link } from '@shopify/polaris';
import { URL } from 'src/constants/links';

type Props = {
  active: boolean,
  handleChange: () => void
};

class LimitCloneModal extends Component<Props> {
  render() {
    const { active, numberOfFilterOptions } = this.props;

    return (
      <Modal
        large
        open={active}
        onClose={this.handleChange}
        title="Reminder: Filter options limited"
        primaryAction={{
          content: 'Got it',
          onAction: this.handleChange
        }}>
        <Modal.Section>
          <TextContainer>
            <p>
              You can <TextStyle variation="strong">only</TextStyle> create filter tree with{' '}
              {numberOfFilterOptions} filter options or less. Please{' '}
              <TextStyle variation="strong">delete</TextStyle> unused options then clone the filter
              tree, or create new filter tree. See{' '}
              <Link external url={URL['FilterOptionBestPractice']}>
                filter options best practice here
              </Link>
              .
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleChange = () => {
    this.props.handleChange();
  };
}

export default LimitCloneModal;
